/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable max-len */

// if (process.env.BROWSER) {
//   throw new Error(
//     'Do not import `config.js` from inside the client-side code.',
//   );
// }

/* eslint-disable camelcase */
const dotenv = require('dotenv');

dotenv.config();

const env = process.env.REACT_APP_ENV || 'staging';

const config = require('@source/global/config')[env];

module.exports = {
  // Node.js app
  env,
  ...config,
  trustProxy: process.env.TRUST_PROXY || 'loopback',
  port: process.env.PORT || 3000,
};
